import { render, staticRenderFns } from "./ReglementsModal.vue?vue&type=template&id=75e722c2&"
import script from "./ReglementsModal.vue?vue&type=script&lang=js&"
export * from "./ReglementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports